// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"767":"96a5a572","829":"da44bfd4","893":"d482a154"}[chunkId] + ".chunk.js");